import { createTheme as muiCreateTheme } from '@mui/material';
import type { Theme } from '@mui/material';
import createPalette from './palette';

export const createTheme = (mode: 'light' | 'dark' = 'light'): Theme => {
  return muiCreateTheme({
    cssVariables: { 
      colorSchemeSelector: 'data-aurora-color-scheme', 
      cssVarPrefix: 'aurora' 
    },
    colorSchemes: {
      light: {
        palette: createPalette('light'),
      },
      dark: {
        palette: createPalette('dark'),
      },
    },
    palette: createPalette(mode),
    typography: {
      fontFamily: [
        'Inter',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
      ].join(','),
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
            backgroundColor: 'var(--aurora-palette-background-default)',
            color: 'var(--aurora-palette-text-primary)',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            borderRadius: '8px',
            fontWeight: 500,
            fontFamily: 'Inter, sans-serif',
            '&:focus-visible': {
              outline: '2px solid var(--aurora-palette-primary-main)',
              outlineOffset: '2px',
            },
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: '12px',
            boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundColor: 'var(--aurora-palette-background-paper)',
            color: 'var(--aurora-palette-text-primary)',
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            '& .MuiOutlinedInput-root': { 
              borderRadius: '8px',
              '& fieldset': { borderWidth: 1 },
              '&:hover fieldset': { borderWidth: 1 },
              '&.Mui-focused fieldset': { 
                borderWidth: 1,
                borderColor: 'var(--aurora-palette-primary-main)',
              },
              '&:focus-within': {
                outline: 'none',
              },
            },
            '& .MuiInputLabel-root': { fontFamily: 'Inter, sans-serif' },
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            fontFamily: 'Inter, sans-serif',
            color: 'var(--aurora-palette-text-primary)',
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: { fontFamily: 'Inter, sans-serif', borderRadius: '8px' },
        },
      },
      MuiFormControl: {
        styleOverrides: { root: { fontFamily: 'Inter, sans-serif' } },
      },
      MuiFormHelperText: {
        styleOverrides: { root: { fontFamily: 'Inter, sans-serif' } },
      },
    },
  });
};
